// statusVisual.js — classificação visual de OS (compartilhada entre Dashboard e Agenda).
// Mesma lógica do backend (routes/dashboard.js → classificarVisita).
//
// Estados retornados:
//   agendada                 — futura
//   proxima_2h               — vai começar em < 2h
//   em_andamento_no_horario  — atendimento iniciado dentro de +10min da janela
//   em_andamento_atrasada    — atendimento iniciado depois de +10min
//   atrasada                 — janela passou, não iniciou
//   concluida                — finalizada
//   cancelada / nao_compareceu — terminal sem sucesso

const TOLERANCIA_INICIO_MIN = 10;
const STATUS_TERMINAIS = new Set(['concluida', 'cancelada', 'nao_compareceu']);

export function classificarVisita(v, agora = new Date()) {
  if (!v) return 'agendada';
  if (v.status === 'concluida')      return 'concluida';
  if (v.status === 'cancelada')      return 'cancelada';
  if (v.status === 'nao_compareceu') return 'nao_compareceu';

  // Em atendimento — sub-status por pontualidade
  if (v.status === 'em_atendimento' || v.status === 'em_execucao') {
    if (v.dt_inicio_atendimento) {
      const iniPrevisto = new Date(v.janela_inicio);
      const iniReal     = new Date(v.dt_inicio_atendimento);
      const atrasoMin   = (iniReal - iniPrevisto) / 60000;
      if (atrasoMin > TOLERANCIA_INICIO_MIN) return 'em_andamento_atrasada';
      return 'em_andamento_no_horario';
    }
    return 'em_andamento_no_horario';
  }

  // Não iniciada
  const inicio = new Date(v.janela_inicio);
  if (inicio < agora && !STATUS_TERMINAIS.has(v.status)) return 'atrasada';
  const diff = (inicio - agora) / 60000;
  if (diff >= 0 && diff <= 120) return 'proxima_2h';
  return 'agendada';
}

// Paleta de cores compartilhada (mantida em UM lugar)
export const COR_STATUS_VISUAL = {
  agendada:                { borda: '#94a3b8', fundo: '#f1f5f9', texto: '#475569', label: 'Agendada',         dot: '#94a3b8' },
  proxima_2h:              { borda: '#fbbf24', fundo: '#fef3c7', texto: '#78350f', label: 'Próxima 2h',       dot: '#fbbf24' },
  em_andamento_no_horario: { borda: '#3b82f6', fundo: '#dbeafe', texto: '#1e3a8a', label: 'Em andamento',     dot: '#3b82f6' },
  em_andamento_atrasada:   { borda: '#f97316', fundo: '#ffedd5', texto: '#7c2d12', label: 'Em and. atrasada', dot: '#f97316' },
  atrasada:                { borda: '#ef4444', fundo: '#fee2e2', texto: '#7f1d1d', label: 'Atrasada',         dot: '#ef4444' },
  concluida:               { borda: '#22c55e', fundo: '#dcfce7', texto: '#14532d', label: 'Concluída',        dot: '#22c55e' },
  cancelada:               { borda: '#d1d5db', fundo: '#f3f4f6', texto: '#4b5563', label: 'Cancelada',        dot: '#d1d5db' },
  nao_compareceu:          { borda: '#dc2626', fundo: '#fee2e2', texto: '#7f1d1d', label: 'Não compareceu',   dot: '#dc2626' },
};

export function corDeVisita(v, agora = new Date()) {
  const sv = classificarVisita(v, agora);
  return COR_STATUS_VISUAL[sv] || COR_STATUS_VISUAL.agendada;
}

// Cor da BARRA "realizado" na agenda — reflete pontualidade do início.
// Quando dt_inicio_atendimento existe, decide pela diferença vs janela_inicio.
//   azul   — iniciado até +10min do horário marcado
//   laranja — iniciado depois de +10min
//   cinza  — sem dt_inicio_atendimento (fallback raro)
// Para cancelada/nao_compareceu, retorna a cor do status (não há "realizado").
export function corRealizado(v) {
  if (!v) return { fundo: '#9ca3af', borda: '#6b7280' };
  if (v.status === 'cancelada' || v.status === 'nao_compareceu') {
    return COR_STATUS_VISUAL[v.status] || COR_STATUS_VISUAL.cancelada;
  }
  if (!v.dt_inicio_atendimento) return { fundo: '#9ca3af', borda: '#6b7280' };

  const iniPrev = new Date(v.janela_inicio);
  const iniReal = new Date(v.dt_inicio_atendimento);
  const atrasoMin = (iniReal - iniPrev) / 60000;

  if (atrasoMin > TOLERANCIA_INICIO_MIN) {
    return COR_STATUS_VISUAL.em_andamento_atrasada;   // laranja
  }
  return COR_STATUS_VISUAL.em_andamento_no_horario;   // azul
}
